import { Box, Typography } from '@mui/material';

const AboutPage = () => {
    return (
        <div>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
                <Box>
                    <Typography variant="h6">About Cambrya</Typography>
                </Box>
            </Box>
            <b>Cambrya</b> is a luxury brand that specializes in creating high-quality, hand-crafted dog food. Our scrupulously tested meals are designed to be timeless and elegant, and are made with the finest materials. We take pride in our attention to detail and craftsmanship, and strive to create masterpieces that are as unique and beautiful as the dogs that eat them.
        </div>
    )
}

export default AboutPage;